import MyCanvas from "./canvas";
const myCanvas = new MyCanvas();
export default myCanvas;
